module.exports = __webpack_public_path__ + "static/media/7.a860cd25.jpg";